export const MAP_API_KEY = 'AIzaSyAIBzK5eD21I3wCd8-eQgr0ne9Ua7ygNZQ';

export const DEFAULT_MARKER_POSITION = {
  lat: 13.0827,
  lng: 80.2707,
};
  
export const DEFAULT_MAP_BOUNDS = {
  north: 13.261166,
  south: 12.802394,
  west: 80.088424,
  east: 80.348195,
};
  
export const DEFAULT_MAP_OPTIONS = {
  restriction: {
    latLngBounds: DEFAULT_MAP_BOUNDS,
    strictBounds: true,
  },
  mapTypeControl: true,
  streetViewControl: true,
  fullscreenControl: true,
  zoomControl: true,
};